import i18n from 'i18n';
import { InferType, object, string } from 'yup';

export const embeddedLoginSchema = object({
  email: string().label(i18n.t('auth:email')).email().required(),
});

export type EmbeddedLoginValues = InferType<typeof embeddedLoginSchema>;
